<template>
  <div>
    <div class="form-group">
      <label>Household:</label>
      <searchable-dropdown
        :o="$data"
        p="selectedHouseholdId"
        :items="households"
        itemText="name"
        itemValue="_id"
        placeholder="Select a household"
      />
      <small class="form-text text-muted">Select the household to generate report for all its accounts</small>
    </div>

    <div class="form-group">
      <label>Date Range:</label>
      <date-picker
        v-model="dateRange"
        :clearable="false"
        class="date-picker"
        format="MMM D, YYYY"
        range
      ></date-picker>
      <small class="form-text text-muted">Select start and end dates</small>
    </div>

    <div class="button-group">
      <button type="button" class="btn btn-outline-secondary action-button" @click="generateReport">
        <i class="fas fa-download mr-2"></i>Download Report
      </button>
    </div>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import moment from "moment";
import { Api } from "./../../../factory";
import { alert } from "./../../../service";
import { searchableDropdown } from "./../../../component";

export default {
  components: {
    DatePicker,
    searchableDropdown
  },
  data() {
    return {
      dateRange: [new Date(), new Date()],
      households: [],
      selectedHouseholdId: ""
    };
  },
  created() {
    this.loadHouseholds();
  },
  methods: {
    async loadHouseholds() {
      try {
        const { data } = await Api.get("households");
        this.households = data.sort((a, b) => a.name.localeCompare(b.name));
      } catch (err) {
        alert.error(`Error loading households: ${err.message}`);
      }
    },
    async generateReport() {
      if (!this.selectedHouseholdId) {
        alert.error("Please select a household");
        return;
      }

      if (!this.dateRange || this.dateRange.length !== 2) {
        alert.error("Please select both start and end dates");
        return;
      }

      const startDateStr = moment(this.dateRange[0]).format("YYYY/MM/DD");
      const endDateStr = moment(this.dateRange[1]).format("YYYY/MM/DD");

      const payload = {
        householdId: this.selectedHouseholdId,
        startDate: startDateStr,
        endDate: endDateStr
      };

      try {
        const { data } = await Api.post("reports/accounts-values", payload);
        this.downloadZip(data);
      } catch (err) {
        alert.error(`Error generating report: ${err.message}`);
      }
    },
    downloadZip(data) {
      if (!data || !data.zipContent || !data.zipFileName) {
        alert.error("Invalid zip file data");
        return;
      }

      const binaryString = window.atob(data.zipContent);
      const bytes = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }

      const blob = new Blob([bytes], { type: "application/zip" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = data.zipFileName;
      link.click();
      window.URL.revokeObjectURL(url);
    }
  }
};
</script>

<style scoped>
.form-group {
  margin-bottom: 20px;
}

.form-group label {
  font-weight: 600;
  margin-bottom: 8px;
  display: block;
  font-size: 14px;
}

.form-text {
  display: block;
  margin-top: 4px;
  font-size: 12px;
  color: #999;
}

.form-control {
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem;
}

::v-deep .date-picker {
  width: 100%;
}

::v-deep .mx-input {
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem;
  height: auto;
}

.button-group {
  display: flex;
  justify-content: center;
  margin-top: 30px;
}

.action-button {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
</style>
